import { TableRow, TableCell } from "@/components/ui/table";
import React from "react";

export const TableSkeletonRow = ({ allColumns, rowIndex }: { allColumns: any[]; rowIndex: number }) => (
	<TableRow key={`skeleton-${rowIndex}`} className="animate-pulse">
		{allColumns.map((column, colIndex) => {
			const cellClass = column.meta?.cellClassName || "";
			const wrap = column.meta?.wrapWithTableCell !== false;

			const skeleton = column.meta?.skeleton ?? <div className="h-10 bg-muted rounded w-full" />;

			return wrap ? (
				<TableCell key={`skeleton-cell-${rowIndex}-${colIndex}`} className={cellClass}>
					{skeleton}
				</TableCell>
			) : (
				<React.Fragment key={`skeleton-cell-${rowIndex}-${colIndex}`}>{skeleton}</React.Fragment>
			);
		})}
	</TableRow>
);
